export const VERSION_NORMATIVA_V1 = '1'
export const VERSION_NORMATIVA_V2 = '2'

export const PREFIJOS_CODIGO_ESTABLECIMIENTO_V2 = [
  {letra: 'M', descripcion: 'Casa matriz'},
  {letra: 'B', descripcion: 'Bodega'},
  {letra: 'S', descripcion: 'Sucursal'},
  {letra: 'P', descripcion: 'Patio'},
]

export const CODIGO_TIPO_ESTABLECIMIENTO_SOLO_V1 = '20'

export const MODALIDAD_CORRELATIVO_POR_DOCUMENTO = 'D'
export const MODALIDAD_CORRELATIVO_POR_ESTABLECIMIENTO = 'E'
export const MODALIDAD_CORRELATIVO_CENTRALIZADO = 'C'

export const NOMBRES_MODALIDAD_CORRELATIVO: Record<string, string> = {
  [MODALIDAD_CORRELATIVO_POR_DOCUMENTO]: 'Por documento',
  [MODALIDAD_CORRELATIVO_POR_ESTABLECIMIENTO]: 'Por establecimiento',
  [MODALIDAD_CORRELATIVO_CENTRALIZADO]: 'Centralizado',
}

export const nombreModalidadCorrelativo = (tipocorrelativo: any): string => {
  const codigo = `${tipocorrelativo ?? ''}`.trim().toUpperCase()
  if (!codigo) return 'Sin definir'
  return NOMBRES_MODALIDAD_CORRELATIVO[codigo] ?? `Modalidad ${codigo}`
}

export const nombreVersionNormativa = (version: any): string => {
  const valor = `${version ?? ''}`.trim()
  if (valor === VERSION_NORMATIVA_V2) return 'Versión 2 (normativa 2.0)'
  if (valor === VERSION_NORMATIVA_V1) return 'Versión 1'
  return 'Sin definir'
}

export const esNormativaV2 = (empresa: any): boolean => {
  if (!empresa) return false
  const version = empresa.versionhacienda ?? empresa.versionHacienda
  if (version === null || version === undefined || version === '') return false
  return `${version}`.trim() === VERSION_NORMATIVA_V2
}

export const MENSAJE_DISTRITO_REQUERIDO =
  'Debe indicar el distrito: la normativa 2.0 lo exige en la dirección del cliente.'

export const MENSAJE_DISTRITO_PENDIENTE =
  'Este cliente no tiene distrito registrado. Selecciónelo para emitir: se guardará en su ficha y no se le volverá a pedir.'

export const MENSAJE_DISTRITO_BLOQUEA_V2 =
  'Falta el distrito del cliente y no se puede continuar. Su empresa emite con la normativa 2.0, ' +
  'y en esa normativa el Ministerio de Hacienda exige el distrito dentro de la dirección del receptor: ' +
  'si el documento se transmitiera sin ese dato, Hacienda lo rechazaría. ' +
  'Seleccione el distrito del cliente y continúe; el dato queda guardado en su ficha y no se le volverá a pedir.'

export const MENSAJE_DISTRITO_AVISO_V1 =
  'Este cliente todavía no tiene distrito registrado. Su empresa emite con la normativa 1, ' +
  'así que puede continuar sin indicarlo. Si lo selecciona ahora queda guardado en la ficha del cliente ' +
  'y el día que su empresa pase a la normativa 2.0 ya no habrá que capturarlo documento por documento.'

export const CODIGO_DOMICILIADO_POR_DEFECTO = '1'

export const camposDistritoReceptorV2 = (empresa: any, distrito: any): {distrito?: string} =>
  esNormativaV2(empresa) ? {distrito: `${distrito ?? ''}`.trim()} : {}

export const camposTerritorialesConValor = (
  formCliente: any
): {departamento?: string; municipio?: string} => {
  const departamento = `${formCliente?.departamento ?? ''}`.trim()
  const municipio = `${formCliente?.municipio ?? ''}`.trim()
  return {
    ...(departamento ? {departamento} : {}),
    ...(municipio ? {municipio} : {}),
  }
}

export const validarDistritoV2 = (empresa: any, distrito: any): string =>
  esNormativaV2(empresa) && `${distrito ?? ''}`.trim() === '' ? MENSAJE_DISTRITO_REQUERIDO : ''

export const faltaDistrito = (distrito: any): boolean => `${distrito ?? ''}`.trim() === ''

export const bloqueaPorDistrito = (empresa: any, distrito: any): boolean =>
  esNormativaV2(empresa) && faltaDistrito(distrito)

export const mensajeBloqueoDistrito = (empresa: any, distrito: any): string =>
  bloqueaPorDistrito(empresa, distrito) ? MENSAJE_DISTRITO_BLOQUEA_V2 : ''

export const avisoDistritoPendiente = (empresa: any, distrito: any): string => {
  if (!faltaDistrito(distrito)) return ''
  return esNormativaV2(empresa) ? MENSAJE_DISTRITO_PENDIENTE : MENSAJE_DISTRITO_AVISO_V1
}

export const codigoTerritorial = (codigo: any): string => {
  const valor = `${codigo ?? ''}`.trim()
  if (!valor) return ''
  return valor.length === 1 ? `0${valor}` : valor
}

export const municipioDerivadoDelDistrito = (
  mapaDistritoMunicipio: any,
  departamento: any,
  distrito: any
): string => {
  const codigoDepartamento = codigoTerritorial(departamento)
  const codigoDistrito = codigoTerritorial(distrito)
  if (!codigoDepartamento || !codigoDistrito) return ''
  return `${mapaDistritoMunicipio?.[codigoDepartamento]?.[codigoDistrito] ?? ''}`.trim()
}

export const municipioEsDelCatalogoVigente = (catalogoMunicipios: any, municipio: any): boolean => {
  const codigo = codigoTerritorial(municipio)
  if (!codigo) return false
  const municipios = Array.isArray(catalogoMunicipios) ? catalogoMunicipios : []
  return municipios.some((item: any) => codigoTerritorial(item?.codigo) === codigo)
}

export const municipioQueCorrigeElDistrito = (
  mapaDistritoMunicipio: any,
  catalogoMunicipios: any,
  departamento: any,
  distrito: any,
  municipioActual: any
): string => {
  const derivado = municipioDerivadoDelDistrito(mapaDistritoMunicipio, departamento, distrito)
  if (!derivado) return ''
  if (municipioEsDelCatalogoVigente(catalogoMunicipios, municipioActual)) return ''
  return derivado
}

export const tiposEstablecimientoPorVersion = (empresa: any, catalogo: any): Array<any> => {
  const tipos = Array.isArray(catalogo) ? catalogo : []
  if (!esNormativaV2(empresa)) return tipos
  return tipos.filter(
    (tipo: any) => `${tipo?.codigo ?? ''}`.trim() !== CODIGO_TIPO_ESTABLECIMIENTO_SOLO_V1
  )
}

export const MENSAJE_TIPO_ESTABLECIMIENTO_REQUERIDO = 'Tipo de establecimiento es requerido'

export const MENSAJE_TIPO_ESTABLECIMIENTO_INVALIDO =
  'Ese tipo de establecimiento no está disponible en la normativa 2.0. Elija uno de la lista.'

export const validarTipoEstablecimiento = (empresa: any, catalogo: any, valor: any): string => {
  const codigo = `${valor ?? ''}`.trim()
  if (codigo === '') return MENSAJE_TIPO_ESTABLECIMIENTO_REQUERIDO

  const tipos = tiposEstablecimientoPorVersion(empresa, catalogo)
  if (tipos.length === 0) return ''

  return tipos.some((tipo: any) => `${tipo?.codigo ?? ''}`.trim() === codigo)
    ? ''
    : MENSAJE_TIPO_ESTABLECIMIENTO_INVALIDO
}

export const fusionDeLaEmpresa = (empresa: any): string => {
  const valor = empresa?.fusion ?? empresa?.Fusion
  return `${valor ?? ''}`.trim()
}

export const TIPO_DOCUMENTO_NIT = '36'

export const LONGITUD_NIT_HOMOLOGADO = 9

export const TOOLTIP_NIT_SUJETO_EXCLUIDO =
  'Hacienda solo acepta el NIT homologado de 9 dígitos, el mismo número del DUI'

export const AVISO_NIT_SUJETO_EXCLUIDO =
  'Este NIT no tiene 9 dígitos. Hacienda puede rechazar el documento al emitirlo con ' +
  '«[receptor.numDocumento] VALOR NO ES PERMITIDO»: del sujeto excluido solo acepta el NIT ' +
  'homologado de 9 dígitos, el mismo número del DUI. Puede continuar y emitir, pero conviene ' +
  'verificarlo antes.'

export const soloDigitos = (valor: any): string => `${valor ?? ''}`.replace(/\D/g, '')

export const esNitDeSujetoExcluido = (tipoDocumento: any): boolean =>
  `${tipoDocumento ?? ''}`.trim() === TIPO_DOCUMENTO_NIT

export const avisoNitSujetoExcluido = (tipoDocumento: any, numDocumento: any): string => {
  if (!esNitDeSujetoExcluido(tipoDocumento)) return ''

  const digitos = soloDigitos(numDocumento)
  if (digitos === '') return ''

  return digitos.length === LONGITUD_NIT_HOMOLOGADO ? '' : AVISO_NIT_SUJETO_EXCLUIDO
}
